export const OrderHistoryData = {
  orderHistoryData: [
    {
      image: '1.png',
      title: 'Long Top',
      status: 'processing',
      statusCode: 'bg-success',
      size: 'XL',
      color: 'Pink',
      articleNumber: 4215738,
      units: 2,
      price: 21,
    },
    {
      image: '13.png',
      title: 'Fancy watch',
      status: 'Processing',
      statusCode: 'bg-success',
      size: 'Free Size',
      color: 'White',
      articleNumber: 5476182,
      units: 3,
      price: 30,
    },
    {
      image: '4.png',
      title: 'Man shoes',
      status: 'processing',
      statusCode: 'bg-success',
      size: 'XL',
      color: 'Pink',
      articleNumber: 1756457,
      units: 1,
      price: 18,
    },
    {
      image: '10.png',
      title: 'Ladies Side Bag',
      status: 'Shipped',
      statusCode: 'bg-success',
      size: 'S',
      color: 'Brown',
      articleNumber: 7451725,
      units: 1,
      price: 13,
    },
    {
      image: '12.png',
      title: 'Ladies Slipper',
      status: 'Shipped',
      statusCode: 'bg-success',
      size: 'XXL',
      color: 'Brown',
      articleNumber: 4127421,
      units: 1,
      price: 6,
    },
    {
      image: '3.png',
      title: 'Fancy Ladies Jacket',
      status: 'Shipped',
      statusCode: 'bg-success',
      size: 'L',
      color: 'Light gray',
      articleNumber: 3581714,
      units: 2,
      price: 24,
    },
    {
      image: '2.png',
      title: 'Ladies Handbag',
      status: 'Shipped',
      statusCode: 'bg-success',
      size: 'L',
      color: 'Black',
      articleNumber: 6748142,
      units: 1,
      price: 15,
    },
    {
      image: '15.png',
      title: 'I phone 13 mobile',
      status: 'Cancelled',
      statusCode: 'bg-danger',
      size: 'No Size',
      color: 'Blue',
      articleNumber: 5748214,
      units: 2,
      price: 500,
    },
    {
      image: '14.png',
      title: 'Watch',
      status: 'Cancelled',
      statusCode: 'bg-danger',
      size: 'Medium',
      color: 'White',
      articleNumber: 2471254,
      units: 1,
      price: 15,
    },
  ],
  orderHistoryColumns: [
    {
      name: 'Product',
      selector: (row) => row.image,
      sortable: true,
    },
    {
      name: 'Product Name',
      selector: (row) => row.details,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Size',
      selector: (row) => row.size,
      sortable: true,
    },
    {
      name: 'Color',
      selector: (row) => row.color,
      sortable: true,
    },
    {
      name: 'Article number',
      selector: (row) => row.articleNumber,
      sortable: true,
    },
    {
      name: 'Units',
      selector: (row) => row.units,
      sortable: true,
    },
    {
      name: 'Price',
      selector: (row) => row.price,
      sortable: true,
    },
  ],
};
